import AuthGuardDisplay from '@components/AuthGuardDisplay';
import Column from '@components/Column';
import Header from '@components/Header';
import Row from '@components/Row';
import colors from '@constants/colors';
import styled from '@emotion/styled';
import { Link } from '@router/Link';
import { AppScreen } from '@stackflow/plugin-basic-ui';
import { ActivityComponentType } from '@stackflow/react';

import AccountManagement from './components/AccountManagement';
import Permissions from './components/Permissions';
import Policies from './components/Policies';

const AccountSettingActivity: ActivityComponentType = () => (
        <AppScreen>
            <Header title='계정 설정' noShadow/>
            <Column as='main' spacing={40}>
                <Container fullWidth
                           as='section'>
                    <AuthGuardDisplay>
                        <AccountManagement/>
                        <Permissions/>
                    </AuthGuardDisplay>
                    <Policies/>
                </Container>
                <AuthGuardDisplay>
                    <Row justify='center' fullWidth>
                        <Link activityName='LogoutModal' activityParams={{}}>
                            <AccountButton>
                                로그아웃
                            </AccountButton>
                        </Link>
                        <Link activityName='AccountTerminationActivity' activityParams={{}}>
                            <AccountButton>
                                회원탈퇴
                            </AccountButton>
                        </Link>
                    </Row>
                </AuthGuardDisplay>
            </Column>

        </AppScreen>
);

const Container = styled(Column)`
`;

const AccountButton = styled.button`
    padding: 16px;
    color: ${colors.gray7};
    font-size: 12px;
    background-color: transparent;
;
`;

export default AccountSettingActivity;
